<div class="overlay" *ngIf="isLoading | async">
    <div class="spinner">
        <div class="spinner-part spinner-part1"></div>
        <div class="spinner-part spinner-part2"></div>
        <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
    </div>
</div>
<div class="container-fluid pl-0">
    <div class="container-inner">
        <div [hidden]="isCreate || isEdit || escalates">
            <div class="header-contFainer">
                <h2>Escalation Matrix</h2>
                <div class="button-container">
                    <button mat-raised-button class="add-button mr-2" (click)="escalate()">Working Hours</button>
                    <button mat-raised-button class="add-button" (click)="add()"><i class="fa fa-plus"
                            aria-hidden="true"></i> Add Escalation</button>
                </div>
            </div>
            <div class="leads-table mb-3">
                <table mat-table [dataSource]="dataSource" matSort class="mat-table">
                    <ng-container matColumnDef="SNo">
                        <th mat-header-cell *matHeaderCellDef> S.No </th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            {{ (paginatorRef.pageIndex * paginatorRef.pageSize) + (i + 1) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="user_type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>User Type</th>
                        <td mat-cell *matCellDef="let element" >
                            {{ element.user_type || '-' }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="escalation_level">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Esc.Level</th>
                        <td mat-cell *matCellDef="let element" style="text-transform: capitalize;">
                            {{ element.escalation_level?.replace('_', ' ') || '-' }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="interval">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Duration (mins)</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.interval || '-' }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="escalation_mode">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Esc.Mode</th>
                        <td mat-cell *matCellDef="let element" style="text-transform: capitalize;">
                            {{getEscalationModes(element.escalation_mode) || '-' }}
                        </td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="element.status == 1 ? 'status_active' : 'status_inactive'">
                            {{element.status ? 'Active' : 'In-Active'}}</td>
                    </ng-container> -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>
                        <td mat-cell *matCellDef="let element" style="text-align: center;">
                            <img [src]="bucketurl + '/images/pen.png'" class="edit-pen" title="Edit"
                                (click)="editData(element)">
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" style="text-align: center; padding: 20px 0;" colspan="8">No data found!
                        </td>
                    </tr>
                </table>
                <mat-paginator #paginatorRef [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
        <ng-container *ngIf="escalates">
            <div class="backbtn">
            <button type="button" class="add-button mdc-button mat-mdc-raised-button mb-2" (click)="back()">Back</button>
            </div>
            <form [formGroup]="escalationHoursForm">
                <div class="row">
                    <div class="col-3">
                <div class="form-group">
                    <label for="working_hour_from">Working Hours From<span style="color: red; font-size: 15px;">&nbsp;*</span></label>
                    <input
                        type="time"
                        id="working_hour_from"
                        formControlName="working_hour_from"
                        class="form-control"
                        required
                    />
                    <div *ngIf="escalationHoursForm.get('working_hour_from')?.invalid && submitted">
                        <small class="text-danger">Working hour from is required.</small>
                    </div>
                </div>
                </div>
                <div class="col-3">
                <div class="form-group">
                    <label for="working_hour_to">Working Hours To<span style="color: red; font-size: 15px;">&nbsp;*</span></label>
                    <input
                        type="time"
                        id="working_hour_to"
                        formControlName="working_hour_to"
                        class="form-control"
                        required
                    />
                    <div *ngIf="escalationHoursForm.get('working_hour_to')?.invalid && submitted">
                        <small class="text-danger">Working hour to is required.</small>
                    </div>
                </div>
                </div>
                <div class="col-3">
                <div class="form-group">
                    <label for="non_escalation_days_from">Non-Escalation Days From</label>
                    <input readonly class="form-control datepick" style="cursor: pointer;" (click)="picker1.open()"
                  [matDatepicker]="picker1" formControlName="non_escalation_days_from" placeholder="Non-Escalation Days From">
                <mat-datepicker #picker1></mat-datepicker>
                </div>
                </div>
                <div class="col-3">
                <div class="form-group">
                    <label for="non_escalation_days_to">Non-Escalation Days To</label>
                    <!-- <input
                        type="date"
                        id="non_escalation_days_to"
                        formControlName="non_escalation_days_to"
                        class="form-control"
                    /> -->
                    <input readonly class="form-control datepick" style="cursor: pointer;" (click)="picker2.open()"
                  [matDatepicker]="picker2" formControlName="non_escalation_days_to" placeholder="Non-Escalation Days To">
                <mat-datepicker #picker2></mat-datepicker>
                </div>
                </div>
            
                </div>
                <div class="row mt-4">
                    <button type="submit" class="btn create-button submit-btn" mat-raised-button (click)="createEscalationHours()" [disabled]="!escalationHoursForm.valid">Submit</button>
                </div>
            </form>
            
        </ng-container>
        <ng-container *ngIf="isCreate || isEdit">
            <div class="header-container">
                <h2>Escalation Matrix</h2>
                <div class="button-container">
                    <button mat-raised-button class="add-button" (click)="back()">Back to List</button>
                </div>
            </div>
            <form [formGroup]="escalationForm">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
                        <div class="themeinput">
                            <label>User Type</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <select class="form-control" formControlName="user_type"
                                [ngClass]="{ 'is-invalid': submitted && f['user_type'].errors }">
                                <option value="" placeholder="example" disabled selected>Select User Type</option>
                                <option *ngFor="let option of options" [value]="option.id">{{ option.label }}</option>
                            </select>
                            <div *ngIf="submitted && f['user_type'].errors" class="invalid-feedback">
                                <div *ngIf="f['user_type'].errors['required']" style="padding-left: 14px;">User Type is
                                    required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
                        <div class="themeinput">
                            <label>Escalation Type</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <select class="form-control" formControlName="escalation_type"
                                [ngClass]="{ 'is-invalid': submitted && f['escalation_type'].errors }">
                                <option value="" placeholder="example" disabled selected>Select Escalation Type</option>
                                <option *ngFor="let option of esc_type" [value]="option.id">{{ option.label }}</option>
                            </select>
                            <div *ngIf="submitted && f['escalation_type'].errors" class="invalid-feedback">
                                <div *ngIf="f['escalation_type'].errors['required']" style="padding-left: 14px;">User
                                    Escalation Type is
                                    required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
                        <div class="themeinput">
                            <label>Escalation Level</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <!-- <mat-select formControlName="escalation_level" placeholder="Escalation Level">
                                <mat-option *ngFor="let option of esc_level" [value]="option.label">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select> -->
                            <select class="form-control" formControlName="escalation_level"
                                [ngClass]="{ 'is-invalid': submitted && f['escalation_level'].errors }">
                                <option value="" placeholder="example" disabled selected>Select Escalation Level
                                </option>
                                <option *ngFor="let option of esc_level" [value]="option.id">{{ option.label }}</option>
                            </select>
                            <div *ngIf="submitted && f['escalation_level'].errors" class="invalid-feedback">
                                <div *ngIf="f['escalation_level'].errors['required']" style="padding-left: 14px;">User
                                    Escalation Level is
                                    required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
                        <div class="themeinput">
                            <label>Email</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <input type="text" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f['email'].errors }" placeholder="Enter Email"
                                formControlName="email">
                            <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                                <div *ngIf="f['email'].errors['required']" style="padding-left: 14px;">
                                    Email is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
                        <div class="themeinput">
                            <label>Contact No</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <input type="text" class="form-control" (keypress)="allowNumbersOnly($event)"
                                [ngClass]="{ 'is-invalid': submitted && f['contact'].errors }"
                                placeholder="Enter Contact" formControlName="contact" maxlength="10" >
                            <div *ngIf="submitted && f['contact'].errors" class="invalid-feedback">
                                <div *ngIf="f['contact'].errors['required']" style="padding-left: 14px;">
                                    Contact is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2" *ngIf="showInterval">
                        <div class="themeinput">
                            <label>Minutes</label>
                            <select class="form-control" formControlName="minutes"
                                [ngClass]="{ 'is-invalid': submitted && f['minutes'].errors }">
                                <option value="" placeholder="example" disabled selected>Select Minutes</option>
                                <option *ngFor="let option of minutes" [value]="option.id">{{ option.label }}</option>
                            </select>
                            <div *ngIf="submitted && f['minutes'].errors" class="invalid-feedback">
                                <div *ngIf="f['minutes'].errors['required']" style="padding-left: 14px;">User Minutes is
                                    required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2"  *ngIf="showInterval">
                        <div class="themeinput">
                            <label>Hours</label>
                            <select class="form-control" formControlName="hours"
                                [ngClass]="{ 'is-invalid': submitted && f['hours'].errors }">
                                <option value="" placeholder="example" disabled selected>Select Hours</option>
                                <option *ngFor="let option of hoursArr" [value]="option.id">{{ option.label }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2"  *ngIf="showInterval">
                        <div class="themeinput">
                            <label>Days</label>
                            <select class="form-control" formControlName="days"
                                [ngClass]="{ 'is-invalid': submitted && f['days'].errors }">
                                <option value="" placeholder="example" disabled selected>Select Days</option>
                                <option *ngFor="let option of daysArr" [value]="option.id">{{ option.label }}</option>
                            </select>
                        </div>
                    </div>
                    <!-- <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
                        <div class="themeinput">
                            <label>Non Escalation Date</label>
                            <mat-form-field class="custom-date-picker" appearance="outline">
                                <input matInput [matDatepicker]="nonEscalationPicker" placeholder="Select Date" formControlName="nonEscalationDate">
                                <mat-datepicker-toggle matIconSuffix [for]="nonEscalationPicker"></mat-datepicker-toggle>
                                <mat-datepicker #nonEscalationPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="themeinput">
                            <label>Non Escalation Date End</label>
                            <mat-form-field class="custom-date-picker" appearance="outline">
                                <input matInput [matDatepicker]="nonEscalationEndPicker" placeholder="Select Date" formControlName="nonEscalationDateEnd">
                                <mat-datepicker-toggle matIconSuffix [for]="nonEscalationEndPicker"></mat-datepicker-toggle>
                                <mat-datepicker #nonEscalationEndPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div> -->
                                       

                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
                        <!-- <div class="themeinput">
                            <label>Escalation Mode</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <select class="form-control" formControlName="escalation_mode"
                                [ngClass]="{ 'is-invalid': submitted && f['escalation_mode'].errors }">
                                <option value="" placeholder="example" disabled selected>Select Escalation Mode</option>
                                <option *ngFor="let option of esc_mode" [value]="option.id">{{ option.label }}</option>
                            </select>
                            <div *ngIf="submitted && f['escalation_mode'].errors" class="invalid-feedback">
                                <div *ngIf="f['escalation_mode'].errors['required']" style="padding-left: 14px;">User
                                    Escalation Mode is
                                    required</div>
                            </div>
                        </div> -->
                        <div class="themeinput">
                            <label>Escalation Mode</label><span style="color: red; font-size :15px">&nbsp;*</span>
                            <ng-multiselect-dropdown [placeholder]="'Select Escalation Mode'" formControlName="escalation_mode"
                              class="form-control singleselect" [settings]="dropdownSettingsMode" [data]="esc_mode"
                              [ngClass]="{ 'is-invalid': submitted && f['escalation_mode'].errors }">
                            </ng-multiselect-dropdown>
                            <div *ngIf="submitted && f['escalation_mode'].errors" class="invalid-feedback">
                              <div *ngIf="f['escalation_mode'].errors['required']">
                                Escalation Mode is required
                              </div>
                            </div>
                          </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2" *ngIf="isEdit && !showInterval">
                        <div class="themeinput">
                            <label>Duration &nbsp;<img src="/assets/images/time-edit.png" alt="" style="cursor: pointer;" title="Edit Duration" (click)="enableInterval()"></label><br>
                            {{this.selectedObject.interval}} mins
                        </div>
                    </div>
                    <div class="col-lg-12 mt-5 mb-5">
                        <div class="text-right-right">
                            <button mat-raised-button *ngIf="isCreate" class="clear-button"
                                (click)="clearForm()">Clear</button>
                            <button *ngIf="isCreate" class="create-button ml-2" mat-raised-button
                                (click)="createEscalation()">Create</button>
                            <button *ngIf="isEdit" class="create-button ml-2" mat-raised-button
                                (click)="update()">Update</button>
                        </div>
                    </div>
                </div>
                <div class="desc">
                    <ul>
                        <li>Working hours should be set in order to raise an escalation only within specific duration &
                            this can be controlled by the Outlet Managers.</li>
                        <li>Escalation will be triggered if in case of leads are untouched & the same will be triggered
                            to the respective Managers.
                        </li>
                        <li>Duration should be set & can be edited if required.
                        </li>
                        <li>Escalation mode can be made to choose WhatsApp & Email by providing the respective Email ID
                            & Phone number even if case of non Mint360 user.
                        </li>
                        <li>It is mandatory to fill all the fields given to an escalation to make the escalation matrix
                            active.
                        </li>
                    </ul>
                </div>
            </form>
        </ng-container>
    </div>
</div>